import classNames from 'classnames';

export const Divider: React.FC<DividerProps> = ({ className }) => (
  <hr className={classNames('w-full border-t border-slate-300', className)} />
);

export interface DividerProps {
  className?: string;
}
